import { Navigate, useLocation } from 'react-router-dom'
import { HOME_ROUTE, STUDENT_CREATE_ROUTE, STUDENTS_ROUTE } from '../../app/router/routes'
import { StudentChange } from '../../features/studentChange'
import { ChooseItems } from '../../features/chooseItems'
import { LayoutPages } from '../layoutPages'
import { useAppSelector } from '../../app/store/store'
import { IStudentChange, useStudentActions } from '../../entities/student'
import { tutorService } from '../../entities/tutor'
import { FEATURES, FEATURE_SECTIONS, hasFeature, hasFeatureGrant } from '../../entities/my'
import { useEffect, useState } from 'react'
import { changeFormError } from '../../shared/lib/helpers/ChangeFormError'
import { IFormError, IItem } from '../../shared/model/types'

export default function StudentChangePage() {
    type ITutorSelectItem = IItem & {user_id?: number}

    const {pathname} = useLocation()

    const isCreate = pathname === STUDENT_CREATE_ROUTE.path;

    const {student} = useAppSelector(s => s.studentReducer)
    const {setTutorUserId, setInitialState} = useStudentActions()

    const {my} = useAppSelector(s => s.myReducer)
    const canOpenStudentsSection = hasFeature(my, FEATURE_SECTIONS.STUDENTS)
    const canListTutors = hasFeatureGrant(my, FEATURES.IDM.STAFF_LIST)
    const canChangeStudent = isCreate
        ? hasFeature(my, FEATURES.STUDENTS.CREATE)
        : hasFeature(my, FEATURES.STUDENTS.CARD_UPDATE, student.user_id)
    const isAccess = canOpenStudentsSection
        && canChangeStudent
        && (!isCreate || canListTutors)
    
    const [formError, setFormError] = useState<IFormError<IStudentChange>[]>([])
    const setErrorFieldDelete = changeFormError(formError, setFormError)

    useEffect(() => {
        return () => {
            setInitialState()
        }
    }, [])

    if(!isAccess){
        return (
            <Navigate to={HOME_ROUTE.path} replace />
        )
    }

    if(!student.id && !isCreate){
        return (
            <Navigate to={STUDENTS_ROUTE.path} replace />
        )
    }

    return (
        <LayoutPages title={STUDENT_CREATE_ROUTE.name}>
            <StudentChange
                formError={formError}
                setFormError={setFormError}
                setErrorFieldDelete={setErrorFieldDelete} 
                isCreate={isCreate} 
                chooseTutor={isCreate ? (
                    <ChooseItems 
                        error={formError.find(error => error.field === 'user_id')?.text}
                        setError={setErrorFieldDelete('user_id')}
                        title='Исполнитель'
                        selectedItems={[Number(student.user_id)]}
                        setItem={setTutorUserId}
                        onSelectItem={(item, selected) => {
                            const tutorItem = item as ITutorSelectItem
                            const selectedUserId = selected ? Number(tutorItem.user_id ?? tutorItem.id ?? -1) : -1
                            setTutorUserId(selectedUserId)
                        }}
                        getData={async () => {
                                const data = await tutorService.getAllV1()
                                const items = data.tutors.map(d => ({
                                    id: d.user_id ?? d.id,
                                    name: d.full_name,
                                    user_id: d.user_id ?? d.id,
                                } as ITutorSelectItem))

                                const selectedTutorUserId = Number(student.user_id ?? -1)
                                if(selectedTutorUserId > 0 && !items.some(item => Number(item.user_id ?? item.id) === selectedTutorUserId)){
                                    let selectedTutorName = student.tutor_name || ''
                                    if(!selectedTutorName){
                                        try{
                                            const selectedTutor = await tutorService.getByUserId(selectedTutorUserId)
                                            selectedTutorName = selectedTutor.full_name
                                        }
                                        catch{
                                            selectedTutorName = `Исполнитель ${selectedTutorUserId}`
                                        }
                                    }

                                    items.unshift({
                                        id: selectedTutorUserId,
                                        name: selectedTutorName,
                                        user_id: selectedTutorUserId,
                                    } as ITutorSelectItem)
                                }

                                return items
                            }
                        }
                        search
                    />
                ) : undefined}
            />
        </LayoutPages>
    )
}
